import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import axios from "axios";
import Notifications, {notify} from "react-notify-toast";
import {validateField, validateEmail, validateDate} from "../../../core/validators";
import {dateToRequestDate} from "../../../core/date";
import styles from "./MortandadModal.module.css";

const MortandadModal = ({ show, handleClose, callback }) => {

    const loadingBtn = require("../../../assets/loaders/btn-loading.gif");

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [loading, setLoading] = useState(false);
        
    const [observation, setObservation] = useState(undefined);
    const [expenseDate, setExpenseDate] = useState(undefined);

    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState(undefined);
    const [potrero, setPotrero] = useState(undefined);
    const [retiro, setRetiro] = useState(undefined);
    const [caravana, setCaravana] = useState(undefined);
    const [carimbo, setCarimbo] = useState(undefined);
    const [causaProbable, setCausaProbable] = useState(undefined);
    const [owner, setOwner] = useState(undefined);
    const [owners, setOwners] = useState([]);        

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }    

    const retrieveOwners = () => {
        let company = cookie.kUserSession.data["company"];
        axios.get(process.env.REACT_APP_API_URL + "owners?company_id=" + company.id , prepareHeaders())
        .then(rs => {
            if(rs.status == 200){
                let data = rs.data;
                setOwners(data);
                setOwner(data[0]);
            }
            else {
                setOwners([]);
                setOwner(undefined);
            }
        })
        .catch(error => {
            console.error(error);
            setOwners([]);
            setOwner(undefined);
        });
    }        

    const validateParams = () => {
        return true;
    }

    const retrieveCategories = () => {
        axios.get(process.env.REACT_APP_API_URL + "category", prepareHeaders())
        .then(rs => {
            console.log(rs);
            if(rs.status == 200){
                let {data} = rs.data;
                setCategories(data);
            }
            else {
                setCategories([]);
            }            
        })
        .catch(error => {
            console.error(error);
            setCategories([]);
        });
    }    

    const save = (body) => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + "movements/entrance/decease", body, prepareHeaders()).then(rs => {
            let data = rs.data;
            setLoading(false);
            callback();
            handleClose();
            notify.show("Deceso registrado exitosamente", "success");
        }).catch(error => {
            console.error(error.response);
            setLoading(false);
            handleClose();
            notify.show("Ha ocurrido un error al crear el deceso", "error");
        });
    }
    
    const handleSave = (e) => {
        if(validateParams()){
            var currentFarm = cookie.kUserSession.data["farm"];
            const body = {
                data: {
                    cantidad: 1,
                    carimbo: parseInt(carimbo),
                    causa_probable: causaProbable,
                    fecha_movimiento: expenseDate,
                    id_categoria: parseInt(category),
                    id_estancia: parseInt(cookie.kUserSession.data["farm"].id),
                    retiro: retiro,
                    nro_caravana: caravana,
                    observacion: observation,
                    potrero: potrero,
                    owner: owner ? owner.id : undefined                    
                }
            };
            console.log(body);
            save(body);
        }
    }

    useEffect(() => {
        retrieveCategories();
        retrieveOwners();        
    }, []);

    return (
        <>
            <Notifications/>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title><b>Nuevo deceso</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group controlId="fecha_gasto">
                                    <Form.Label>Fecha</Form.Label>
                                    <Form.Control className="karanda-input" value={expenseDate} onChange={(e) => { setExpenseDate(e.target.value); }} type="date" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="nro_guia">
                                    <Form.Label>Caravana N°</Form.Label>
                                    <Form.Control className="karanda-input" value={caravana} onChange={(e) => { setCaravana(e.target.value); }} type="text" placeholder="Ingrese la guía" />
                                </Form.Group>                        
                            </Col>
                            <Col>
                                <Form.Group controlId="nro_cota">
                                    <Form.Label>Zona</Form.Label>
                                    <Form.Control className="karanda-input" value={retiro} onChange={(e) => { setRetiro(e.target.value); }} type="text"/>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="categoria">
                                    <Form.Label>Potrero</Form.Label>
                                    <Form.Control className="karanda-input" value={potrero} onChange={(e) => {setPotrero(e.target.value);}} type="text"/>
                                </Form.Group>
                            </Col>                            
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="categoria">
                                    <Form.Label>Categoría</Form.Label>
                                    <Form.Control className="karanda-input" value={category} onChange={(e) => { setCategory(e.target.value); }} as="select">
                                        <option value={0} disabled selected>Seleccione</option>
                                        {
                                            categories.map((i) => (
                                                <option value={i.id_categoria}>{i.nombre}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>                        
                            </Col>
                            <Col>
                                <Form.Group controlId="owner">
                                    <Form.Label>Propietario</Form.Label>
                                    <Form.Control as="select" value={ owner != undefined ? owner.id : undefined} className="karanda-input" onChange={(e) => {setOwner({...owner, id: e.target.value});}}>
                                        <option value={0} selected disabled>Seleccione el propietario</option>
                                        {
                                            owners.map((i) => (
                                                <option value={i.id}>{i.nombres + " " + i.apellidos}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>                            
                            <Col>
                                <Form.Group controlId="carimbo">
                                    <Form.Label>Carimbo</Form.Label>
                                    <Form.Control className="karanda-input" value={carimbo} onChange={(e) => { setCarimbo(e.target.value); }} type="number" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="observacion">
                                    <Form.Label>Causa probable</Form.Label>
                                    <Form.Control className="karanda-input" value={causaProbable} onChange={(e) => {setCausaProbable(e.target.value)}} type="text" placeholder="Ingrese causa probable" />
                                </Form.Group>
                            </Col>
                        </Row>                        
                        <Row>
                            <Col>
                                <Form.Group controlId="observacion">
                                    <Form.Label>Observaciones</Form.Label>
                                    <Form.Control className="karanda-input" value={observation} type="text" placeholder="Observacion" onChange={(e) => { setObservation(e.target.value); }} />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
                    <Button variant="primary"
                        onClick={handleSave}>
                        {
                            loading ? (
                                <img src={loadingBtn} height="15"/>
                            ) : (<span>Registrar</span>)
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );

};

export default MortandadModal;